import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { LS } from 'src/app/helpers/localStorage.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  API_SERVER: string = environment.baseApiUrl;

  constructor(
    public httpClient: HttpClient,
    private router: Router,
  ) { }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  login(data): Observable<any> {
    return this.httpClient.post(this.API_SERVER + 'auth/login', data);
  }

  logout() {
    return this.httpClient
      .get(this.API_SERVER + 'auth/logout')
      .pipe(map(this.extractData));
  }

  register() {
    return this.httpClient
      .get(this.API_SERVER + 'login')
      .pipe(map(this.extractData));
  }

  forgetpass(data) {
    /** To generate the email, user/forgotPassword requires front-end url (hostname) or else the email will default to 'suntory-staging.aerodyne.dev' */
    const hostname = location.hostname
    return this.httpClient.post(this.API_SERVER + 'user/forgotPassword', {...data, hostname });
  }

  resetpass(data) {
    return this.httpClient.post(this.API_SERVER + 'user/resetPassword/:token', data);
  }

  resetPassword(data, token): Observable<any> {
    return this.httpClient.put(this.API_SERVER + `user/reset/${token}`, {password: data});
  }

  setPasswordResetToken(token) : Observable<any>{
    return this.httpClient.get(this.API_SERVER + `user/resetPassword/${token}`);
  }


  // createAuthrorizationHeader(): HttpHeaders {
  //   let headers = new HttpHeaders({
  //     Authorization: localStorage.getItem('jwt'),
  //   });
  //   return headers;
  // }

  // authorise() {
  //   let header = this.createAuthrorizationHeader();
  //   return this.httpClient
  //     .get(this.API_SERVER + 'auth', { headers: header })
  //     .pipe(map(this.extractData));
  // }

  // async getIdFromJwt() {
  //   let header = this.createAuthrorizationHeader();
  //   return this.httpClient
  //     .get(this.API_SERVER + 'auth/test', { headers: header })
  //     .pipe(map(this.extractData));
  // }

  isAuthenticated() {
    //return true;
    let currentUser = JSON.parse(localStorage.getItem(LS.currentUser));
    if (currentUser && currentUser.token) return true;
    return false;
  }
}
